import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import fetchApi from '../../../utils/api/fetchApi';
import systematic from '../../../config/systematic';
import { Button, Col, Form, Input, Row, Select, Upload } from 'antd';
import AntdNotification from '../../../utils/extend/AntdNotification';
import getList from '../../../utilsTsx/universal/getList';
import { useEffect, useState } from 'react';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import { convert } from 'html-to-text';
import { UploadOutlined } from '@ant-design/icons';
import antMessage from '../../../utils/extend/AntdNotification';
import filesApis, { UploadReturn } from '../../../utilsTsx/components/files/filesApis';

export declare interface SendAnEmailDataType {
    /** 邮件供应商id */
    emailSupplierId: string;
    /**　收件人 */
    recipientsEmail?: string;
    /** 主题 */
    subject?: string;
    /** 内容 */
    bodyHtml?: string;
}

const SendAnEmail = (props: any) => {
    const { data, onClose } = props;
    const { emailSupplierId, recipientsEmail, subject, bodyHtml } = data as SendAnEmailDataType;
    const [form] = Form.useForm(); //form 
    /** 后端数据defaultService */
    const defaultService = systematic.businessService;
    const [emailTemplateData, setEmailTemplateData] = useState<any>();
    const [uploadOptions, setUploadOptions] = useState<UploadReturn>();

    useEffect(() => {
        fetchApi.GET(defaultService,
            {
                apiId: 'emailTemplate',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setEmailTemplateData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                apiId: 'emails',
                apiExtend: 'getConfig'
            }).then(res => {
                if (res.success === true) {
                    const {
                        // emailsServerId,
                        emailsServiceId,
                        emailsFilesGroupId,
                        filesServerUrl } = res.data;
                    // console.log('getConfig: ',res.data);

                    filesApis.upload({
                        // filesServerId: emailsServerId,
                        defaultService,
                        serverUrl: filesServerUrl,
                        serviceId: emailsServiceId,
                        filesGroupId: emailsFilesGroupId,
                        fileValidityPeriodId: 'fixedTerm'
                    }).then(apiRes => {
                        if (apiRes.success === true) {
                            setUploadOptions(apiRes.data);
                        }
                    })
                }
            })

    }, []);

    /**
     * 创建邮件
     */
    const generateEmail = async () => {
        /** 邮件模版id */
        const emailTemplateId = form.getFieldValue('emailTemplateId');
        /** 替换字 */
        const replacements = form.getFieldValue('replacements');
        fetchApi.POST(defaultService,
            {
                apiId: 'emails',
                apiExtend: 'generateEmail',
                apiData: {
                    emailTemplateId,
                    replacements
                }
            }).then(res => {
                if (res.success) {
                    form.setFieldValue('bodyHtml', res.data);
                }
            })
    };

    /**
    * 发送html邮件
    * @param currentId 
    * @returns 
    */
    const sendHtmlEmail = async () => {
        const rtn = await fetchApi.POST(defaultService, {
            apiId: 'emails',
            apiExtend: 'sendHtmlMail',
            apiData: {
                emailSupplierId,
                subject: form.getFieldValue('subject'),
                recipientsEmail: form.getFieldValue('recipientsEmail'),
                recipientsCC: form.getFieldValue('recipientsCC'),
                bodyHtml: form.getFieldValue('bodyHtml'),
                bodyText: form.getFieldValue('bodyText'),
                attachmentList: fileList
            }
        });
        if (rtn.success === true) {
            AntdNotification('success', '发送成功');
            onClose();
        } else {
            AntdNotification('error', `发送失败!${rtn?.message}`);
        }
    };

    const handleOk = async (e: any) => {
        try {
            await form.validateFields();
            // 校验通过，执行发送
            sendHtmlEmail();
        } catch (errorInfo) {
            // 校验失败，Antd 会自动提示错误信息，无需额外处理
            console.log('表单校验失败:', errorInfo);
        }
    };

    const handleCancel = (e: any) => {
        onClose();
    }

    /** 上传的文件类型 */
    interface UploadFileType {
        /** 文件在线地址 */
        fileUrl: string;
        /** 文件类型 */
        type: string;
        /** 文件大小 */
        size: number;
        /** uid */
        uid: string;
        /**　文件名 */
        name: string;
        /** 文件服务器的文件id */
        fileId: string;
    };

    const [fileList, setFileList] = useState(Array<UploadFileType>);

    const uploadHandleChange = (info: any) => {
        // 从 info.fileList 中复制一份，避免直接修改原对象
        let newFileList = [...info.fileList];
        // 处理刚刚上传成功的文件
        if (info.file.status === 'done') {
            const { response } = info.file;
            // 将 id 直接存到 file 对象上（
            newFileList = newFileList.map((file) => {
                if (file.uid === info.file.uid) {
                    return {
                        /** 文件在线地址 */
                        fileUrl: `${response?.data?.filesServer}/${response?.data?.destination}/${response?.data?.fileName}`,
                        /** 文件类型 */
                        type: file.type,
                        /** 文件大小 */
                        size: file.size,
                        uid: file.uid,
                        /**　文件名 */
                        name: file.name,
                        /** 文件服务器的文件id */
                        fileId: response?.data?.id
                    };
                }
                return file;
            });
        }
        setFileList(newFileList);
    };

    return (
        <>
            <AntDraggableModal
                title={`发邮件`}
                open={true}
                okText='发送'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={1100}>
                <Form
                    form={form}
                    name="Edit">
                    <Row gutter={[8, 0]}>

                        <Col span={6}>
                            <Form.Item
                                label="模版"
                                name="emailTemplateId"
                                tooltip='邮件内容根据模版生成'>
                                <Select
                                    showSearch
                                    placeholder="邮件模版"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(emailTemplateData, {
                                        includeNull: true,
                                        itemName: 'templateName'
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={15}>
                            <Form.Item
                                label="数据"
                                name="replacements"
                                tooltip='邮件替换数据，格式：{ name: "我的邮件" }'>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label=" "
                                tooltip='根据模版和数据创建邮件内容'>
                                <Button type='primary' onClick={generateEmail}>创建</Button>
                            </Form.Item>
                        </Col>

                        <Col span={16}>
                            <Form.Item label="收件"
                                name="recipientsEmail"
                                tooltip='收件人地址：例如：xxx@qq.com'
                                initialValue={recipientsEmail}
                                rules={[{ required: true, message: '收件!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="抄送"
                                name="recipientsCC">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={16}>
                            <Form.Item label="主题"
                                name="subject"
                                initialValue={subject}
                                rules={[{ required: true, message: '主题!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label=" "
                                tooltip='邮件附件'>
                                <Upload
                                    {...uploadOptions?.config}
                                    showUploadList={true}
                                    fileList={fileList}
                                    onChange={uploadHandleChange}
                                    onRemove={(file: UploadFileType) => {
                                        const { serviceId } = uploadOptions || {};
                                        const { action } = uploadOptions?.config;
                                        const { fileId } = file;
                                        fetchApi.DELETE(action, {
                                            apiId: 'files',
                                            apiExtend: 'deleteFiles',
                                            apiData: {
                                                filesIds: [{ id: fileId }]
                                            }
                                        },
                                            undefined, { serviceId }
                                        ).then(res => {
                                            if (res.success === true) {
                                                antMessage('success', '删除成功', 'success');
                                            }
                                            else {
                                                antMessage('error', '删除失败', res.message);
                                            }
                                        })
                                    }}>
                                    <Button icon={<UploadOutlined onPointerOverCapture={undefined} onPointerMoveCapture={undefined} />}>附件</Button>
                                </Upload>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="内容"
                                name="bodyHtml"
                                tooltip='邮件html内容'
                                initialValue={bodyHtml}
                                rules={[{ required: true, message: '邮件html内容!' }]}>
                                <WangeditorV5ForAntD
                                    id="sendAnEmail"
                                    displayMode="editor"
                                    style={{ height: 500 }}
                                    defaultService={systematic.bmService}
                                    onChange={(e) => {
                                        form.setFieldValue('bodyText', convert(e));
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="文字"
                                name="bodyText"
                                tooltip='邮件纯文字，通过内容生成'>
                                <Input.TextArea
                                    autoSize={{ minRows: 1, maxRows: 6 }}
                                    disabled={true}
                                />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}
export default SendAnEmail;